// These must be the first lines in src/index.js
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

// import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import './custom.scss';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router';

// import './i18n';

window.RUNTIME_CONFIG = { env: null };

async function bootstrap() {
  try {
    const res = await fetch('/fptpayment/api/config/env');
    const env = await res.text();

    window.RUNTIME_CONFIG.env = env;

    if (['prd', 'prdsb', 'prdws'].includes(env)) {
      console.log = () => {};
    }

	await import('./i18n'); // runs your i18n init using runtime env

    const { default: App } = await import('./App');

    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <BrowserRouter>
        <App />
      </BrowserRouter>
    );
  } catch (err) {
    console.error('Failed to initialize app:', err);
    document.body.innerHTML = '<h2>Failed to load configuration. Please try again later.</h2>';
  }
}

// Kick off the app once everything is ready
bootstrap();


// if (process.env.REACT_APP_ENV === 'prd' || process.env.REACT_APP_ENV === 'prdsb' || process.env.REACT_APP_ENV === 'prdws') {
// 	console.log = () => {};
// }

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
// 	// <React.StrictMode>
// 	<BrowserRouter>
// 		<App />
// 	</BrowserRouter>
// 	// </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
